import { Carto } from '../common/carte/carte-config.js';
import {
  initMapForDossier,
  loadFeatureForMap,
} from '../common/carte/carte-util.js';
import { LayerSwitcherControl } from '../common/carte/layer-switcher-control.js';

export function initCarto() {
  const map = initMapForDossier(
    'carte-dossier',
    {},
    {
      maxZoom: 20,
    },
  );

  // Shutdown des boutons de la map, on ne veut que du visuel et des interactions à base de scroll
  // (à l'exception de l'outil de changement de fond de plan)
  map
    .getControls()
    .getArray()
    .filter((control) => !(control instanceof LayerSwitcherControl))
    .forEach((control) => map.removeControl(control));

  if (Carto.dossierGeoref) {
    map
      .getView()
      .fit([
        Carto.dossierGeoref.minX,
        Carto.dossierGeoref.minY,
        Carto.dossierGeoref.maxX,
        Carto.dossierGeoref.maxY,
      ]);
    loadFeatureForMap(
      map,
      null,
      Carto.dossierGeoref?.dossierId ? [Carto.dossierGeoref.dossierId] : null,
    );
  } else {
    document.querySelector('#masque-no-georef').style.display = 'block';
  }

  return {
    updateSize: () => map.updateSize(),
  };
}
